import focus from "./focus";
import clickoutside from "./clickoutside";
import contextMenu from "./contextMenu";
import putInDialog from "./putInDialog";
import dblclick from "./dblclick";
import title from "./title";
import './loading'

function install(Vue){
  Vue.use(focus);
  Vue.use(clickoutside);
  Vue.use(contextMenu);
  Vue.use(putInDialog);
  Vue.use(dblclick);
  Vue.use(title);
  // Vue.use(loading)
}

export {
  install,
  focus,
  clickoutside,
  // loading
}
export default install;